import { type ReactNode, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SupplierLogo } from '@/components/resultList/images/SupplierLogo';
import type { PaleState, ThunkDispatchFunc } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { fetchResults } from '@/state/resultActions';
import { type CheckboxDispatchProps, CheckboxFilter } from './CheckboxFilter';

export const CharterSupplierFilter = () => {
    const dispatch = useDispatch<ThunkDispatchFunc>();

    const facetList = useSelector((s: PaleState) => s.results.facets.charterSuppliers);
    const checkboxValues = useSelector((s: PaleState) => s.filters.suppliers);

    const displayValues = useMemo<Record<string, ReactNode>>(
        () => Object.fromEntries((facetList ?? []).map((s) => [s.value, <SupplierLogo key={s.value} supplier={s.value} />])),
        [facetList],
    );

    const hasOptions = Array.isArray(facetList) && facetList.length > 0;

    const checkBoxClick: CheckboxDispatchProps['checkBoxClick'] = (valueOrMap) => {
        dispatch(actions.filterCheckboxSupplier(valueOrMap));
    };

    const fetchResultsProxy: CheckboxDispatchProps['fetchResults'] = (queryParams) => {
        dispatch(fetchResults(queryParams));
    };

    return hasOptions ? (
        <CheckboxFilter
            id="charterSupplierFilter"
            label="Charter"
            facetList={facetList}
            displayValues={displayValues}
            checkboxValues={checkboxValues}
            checkBoxClick={checkBoxClick}
            fetchResults={fetchResultsProxy}
        />
    ) : null;
};
